import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'tareasChecklist',
})
export class TareasChecklistPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {


    if (filter['menu'] == 'pendent') {

      items = items.filter(function (item) {

        return !item.value;

      });
    }


    if (filter['menu'] == 'mias') {

      //items = items.filter( (item) => item.ids_users.includes(filter['id_usuario']) || item.ids_roles.includes(filter['id_role']));
      items = items.filter((item) => false);
    }


    if (filter['menu'] == 'incidencias') {

      items = items.filter((item) => item.observaciones != null);

    }


    if (filter['filtros_dash'] && filter['filtros_dash'] == 3) {

      items = items.filter(function (item) {

        return item.observaciones;

      });
    }

    if (filter['search']) {
      items = items.filter((item) => item.label.toLowerCase().includes((filter['search']).toLowerCase()));
    }

    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/tareas-checklist/tareas-checklist.ts